import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ThemeType } from "../../../redux/constants";
import {
    selectCurrentPage,
    updateCurrentPage,
} from "../../../redux/slices/currentPageSlice";
import {
    selectAllRegistration,
    updateRegistrationStoreCart,
} from "../../../redux/slices/registrationSlice";
import { selectAllClassifications } from "../../../redux/slices/classificationsSlice";
import { selectThemeSettings } from "../../../redux/slices/cmsSettingsSlice";
import {
    selectAllP2pSettings,
    selectBaseUrl,
} from "../../../redux/slices/p2pSettingsSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectErroredEntities } from "../../../redux/slices/raceConditionsSlice";
import StorePage from "./StorePage";

const ConnectedStorePage = () => {
    const currentPage = useSelector(selectCurrentPage);
    const registration = useSelector(selectAllRegistration);
    const {
        storeCart = [],
        classification = {},
        allowEarlyFormSubmissionStorePage,
    } = registration;

    // Registration level stored classification
    const { Classification = [] } = classification;
    // Event level active classifications
    const classifications = useSelector(selectAllClassifications);
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.HEADER, state),
    );
    const {
        primaryRegProgressBar: { storeStepLabel = "Add-ons" },
    } = themeSettings;

    const p2pSettings = useSelector(selectAllP2pSettings);
    const { enableClassifications } = p2pSettings;
    const formSettings = useSelector(selectAllFormSettings);
    const { title } = formSettings;
    const erroredEntities = useSelector(selectErroredEntities);
    const documentTitle = `${title} | ${storeStepLabel}`;

    const getSavedCartValues = () => {
        if (storeCart && Object.keys(storeCart).length) {
            return {
                ...storeCart,
            };
        }
        return {};
    };
    const baseUrl = useSelector(selectBaseUrl);

    const registrationRedirect =
        Object.keys(registration.registrations[0]).length === 0
            ? `${baseUrl}/form/registration`
            : undefined;

    const redirect =
        enableClassifications &&
        classifications.length > 0 &&
        Classification.length < 1
            ? `${baseUrl}/form/classification`
            : registrationRedirect;

    const savedCartValues = getSavedCartValues();
    const hasProducts = true;

    const navigate = useNavigate();

    const replaceMeProps = {
        baseUrl,
        currentPage,
        documentTitle,
        erroredEntities,
        redirect,
        hasProducts,
        allowEarlyFormSubmissionStorePage,
        navigate,
        savedCartValues,
        // Actions
        updateRegistrationStoreCart,
        updateCurrentPage,
    };
    return <StorePage {...replaceMeProps} />;
};

export default ConnectedStorePage;
